/**
 * O PRODUTO QUE SE DIZ PELO NOME (pente fino de 31/10/2026).
 *
 * Quem cadastra "ARLA 32" não devia ter de escolher "ARLA" na categoria logo
 * abaixo, nem "Litro" na unidade: o nome já respondeu. A tela sugere as duas,
 * com a marca de pré-preenchido, enquanto a pessoa não as escolheu à mão.
 *
 * E a UNIDADE SEGUE A CATEGORIA: combustível e ARLA se medem em litro (a ajuda
 * do campo já dizia isso); graxa, em quilo. Lubrificante líquido fica em litro.
 *
 * Só sugere. O banco continua aceitando qualquer combinação válida, e quem
 * cadastra troca a sugestão por outra.
 */

export type Categoria = 'combustivel' | 'lubrificante' | 'arla' | 'outro';

/** A categoria que o nome sugere, ou `null` quando ele não diz. */
export function categoriaPeloNome(nome: string): Categoria | null {
  const texto = nome.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  if (/\barla\b/.test(texto)) return 'arla';
  if (/\b(diesel|gasolina|etanol|alcool|gnv|s10|s500|biodiesel)\b/.test(texto)) return 'combustivel';
  if (/\b(graxa|lubrificante|oleo|hidraulico|transmissao|atf)\b/.test(texto)) return 'lubrificante';
  return null;
}

/** A unidade que a categoria (e o nome, para a graxa) pede. */
export function unidadePelaCategoria(categoria: string, nome: string): 'L' | 'kg' | null {
  if (categoria === 'combustivel' || categoria === 'arla') return 'L';
  if (categoria === 'lubrificante') return /graxa/i.test(nome) ? 'kg' : 'L';
  return null;
}
